import { SPACE } from '@/app/helpers/types/space'

export const calendar = {
  today: `Aujourd’hui${SPACE.NNBSP}: {{date}}`,
}
